import React from 'react';
import PropTypes from 'prop-types';

/** Used for buddy tips for less prioritized, short situational-based call outs.
 * Non interactive, Flat variant.
 */
export const FlatBuddyTip = ({ icon, children }) => (
  <div className="buddytip-container buddytip-container__middle buddytip-container--flat">
    <div className="buddytip-container__img">{icon}</div>
    <span>{children}</span>
  </div>
);

FlatBuddyTip.propTypes = {
  /** Icon to be shown on the left */
  icon: PropTypes.node.isRequired,
  /** Text to be shown on the right */
  children: PropTypes.node.isRequired
};
